import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertComponent } from '../../../structure//alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplianceMasterService } from '../../../services/compliance-master.service'
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import * as _ from 'lodash';
import { TaskService } from '../../../services/task.service';
// import { DynamicFormService } from '../../../services/dynamicForm.service'
import { BranchAndDepartmentService } from '../../../services/branch-and-department.service';

declare var $: any;
var moment = require('moment');

@Component({
  selector: 'app-activated-compliance-certificate-list',
  templateUrl: './activated-compliance-certificate-list.component.html',
  styleUrls: ['./activated-compliance-certificate-list.component.css']
})
export class ActivatedComplianceCertificateListComponent implements OnInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  dtOptionsForDetails: DataTables.Settings = {};
  dtTriggerForDetails: Subject<any> = new Subject();

  masterComplianceCertificateData: any[];
  activatedComplianceCertificateData: any[];
  complianceCertificateId: any;
  dataAvailable: boolean;
  users: any[];
  departmentList = [];
  branchList = [];
  searchParam: any = {};
  periodicityData: any[];

  constructor(
    private ComplianceMasterService: ComplianceMasterService, private router: Router,private taskService: TaskService,
    private branchAndDepartmentService: BranchAndDepartmentService,private activatedRoute: ActivatedRoute, ) { }

  ngOnInit() {
    this.getDeptAndBranchMasterData('RegisterDepartmentMaster');
    this.getDeptAndBranchMasterData('RegisterBranchMaster')
    this.getUsersList();
    this.getMasterActivatedComplianceCertificate();
    this.getPeriodictyData();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [{
        text: '<i class="fa fa-files-o"></i> Export to Excel',
        className: 'btn btn-sm btn-warning export-btn',
        filename: 'Compliance Certificate List',
        title: 'Compliance Certificate List',
        extend: 'excel',
        exportOptions: {
          columns: [0, 1, 2],
          format: {
            body: function ( data, row, column, node ) {
                if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                  if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                }else{ return data }
              }
          }
        }
      }]
    };

    this.dtOptionsForDetails = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [{
        text: '<i class="fa fa-files-o"></i> Export to Excel',
        className: 'btn btn-sm btn-warning export-btn',
        filename: 'Compliance Certificate List',
        title: 'Compliance Certificate List',
        extend: 'excel',
        exportOptions: {
          columns: [0],
          format: {
            body: function ( data, row, column, node ) {
                if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                  if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                }else{ return data }
              }
          }
        }
      }]
    };

  }

  getMasterActivatedComplianceCertificate() {
    $("#compliance").DataTable().destroy();
    this.ComplianceMasterService.getMasterActivatedComplianceCertificate(this.searchParam)
      .subscribe(dataList => {
        if (dataList.status == 0) {
          this.masterComplianceCertificateData = [];
          this.dataAvailable = true;
          this.masterComplianceCertificateData = dataList.data;
          this.dtTrigger.next();
        } else {
          this.masterComplianceCertificateData = [];
          this.dataAvailable = false;
          this.dtTrigger.next();
        }
      })
  }

  getActivatedComplianceCertificateByMasterId(id) {
    this.ComplianceMasterService.getActivatedComplianceCertificateByMasterId(id).subscribe(data => {
      if (data.status == 0) {
        var table1 = $('#activatedCert').DataTable({ destroy: true });
        table1.destroy();
        this.activatedComplianceCertificateData = [];
        let self = this;
        data.data.forEach(function (element) {
          if (element.submittedBy) {
            element.submittedByName = "";
            let filteredUser = _.filter(self.users, function (element) {
              return element._id == element.submittedBy
            })
            if (filteredUser && filteredUser.length > 0) {
              element.submittedByName = filteredUser[0].FirstName + " " + filteredUser[0].LastName;
            }
          }
        })
        this.activatedComplianceCertificateData = data.data;
        this.dtTriggerForDetails.next();
        $('#certificateDetails').modal('toggle');
      }
    });
  }
addComplianceCertificate(){
this.router.navigate(
      [{ outlets: { 'structure-outlet': ['complianceCertificate','add']  } }],
      { relativeTo: this.activatedRoute.parent });
}
  getUsersList() {
    this.users = [];
    this.taskService.getUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          this.users = result.result
        }
      })
  }


  getDeptAndBranchMasterData(collectionName) {
    if (collectionName == "RegisterDepartmentMaster") {
      this.departmentList = [];
      this.branchAndDepartmentService.getDepartment().subscribe((response:any) => {
        if (response.status == 0) {
          this.departmentList = response.data;
        }
      })
    } else if (collectionName == "RegisterBranchMaster") {
      this.branchAndDepartmentService.getBranch().subscribe((response:any) => {
        if (response.status == 0) {
          this.branchList = [];
          this.branchList = response.data;
        }
      })
    }
  }
  editComplianceCertificate(id) {
    $('#certificateDetails').modal('toggle');
     this.router.navigate(
      [{ outlets: { 'structure-outlet': ['activatedComplianceCertificate','edit',id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/activatedComplianceCertificate/edit/' + id]);
  }

  getPeriodictyData() {
    this.periodicityData = [];
    this.ComplianceMasterService.getPeriodicityData()
      .subscribe((response:any) => {
        if (response.status == 0) {
          this.periodicityData = response.data;
        }
      })
  }

  clear() {
    this.searchParam = {}
  }
}

